// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.event {
  background-color: #276086 ; /* Change to your preferred color */
    color: #FFFFFF; /* Ensure text is white for better contrast */
  /* text-overflow: ellipsis; */
    border-radius: 8px;
    border: none;
    font-size: inherit;
    font-size: 13px;
    height: 80px;
    
  }
  
  
  
  @media (max-width: 640px) {
    .event {
      font-size: 10px;
    }
  }
  

  `, "",{"version":3,"sources":["webpack://./src/Components/cal.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,0BAA0B,EAAE,mCAAmC;IAC7D,cAAc,EAAE,6CAA6C;EAC/D,6BAA6B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;;EAEd;;;;EAIA;IACE;MACE,eAAe;IACjB;EACF","sourcesContent":["/* styles.css */\n.event {\n  background-color: #276086 ; /* Change to your preferred color */\n    color: #FFFFFF; /* Ensure text is white for better contrast */\n  /* text-overflow: ellipsis; */\n    border-radius: 8px;\n    border: none;\n    font-size: inherit;\n    font-size: 13px;\n    height: 80px;\n    \n  }\n  \n  \n  \n  @media (max-width: 640px) {\n    .event {\n      font-size: 10px;\n    }\n  }\n  \n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
